export default function HeroSection() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=Abstract%20artistic%20visualization%20of%20streaming%20video%20content%20with%20flowing%20colorful%20light%20ribbons%20merging%20and%20separating%20representing%20diverse%20entertainment%20genres%20warm%20coral%20and%20gold%20tones%20against%20deep%20dark%20background%20cinematic%20atmosphere%20with%20soft%20glowing%20particles%20modern%20digital%20art%20style%20high%20detail%20harmonious%20composition&width=1600&height=900&seq=hero-bg-69video&orientation=landscape)',
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/70"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 flex-wrap justify-center lg:justify-start mb-4">
              <span className="px-3 py-1 rounded-full text-xs font-medium bg-primary-500/20 text-primary-200 border border-primary-400/30 whitespace-nowrap">
                丝瓜视频
              </span>
              <span className="px-3 py-1 rounded-full text-xs font-medium bg-accent-500/20 text-accent-200 border border-accent-400/30 whitespace-nowrap">
                蓝莓视频
              </span>
              <span className="px-3 py-1 rounded-full text-xs font-medium bg-primary-500/20 text-primary-200 border border-primary-400/30 whitespace-nowrap">
                糖心视频
              </span>
              <span className="px-3 py-1 rounded-full text-xs font-medium bg-accent-500/20 text-accent-200 border border-accent-400/30 whitespace-nowrap">
                黑桃视频
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight mb-4">
              69视频 — 特色视频网站大全
              <br className="hidden sm:block" />
              发现你的专属观影世界
            </h1>

            <p className="text-base md:text-lg text-white/70 font-light mb-4 max-w-xl mx-auto lg:mx-0">
              海量特色视频资源，一站聚合随心看
            </p>

            <p className="text-sm md:text-base text-white/55 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              69视频汇聚丝瓜视频、蓝莓视频、糖心视频、黑桃视频、妖精视频、桃花视频等众多特色视频网站，
              每日更新海量高清影视资源，涵盖热门电影、电视剧、综艺、动漫等内容类型。
              无需注册即可免费在线观看，支持多设备流畅播放，是你探索独特视频内容的首选平台。
            </p>

            <div className="flex flex-wrap items-center gap-6 justify-center lg:justify-start mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">
                  20+
                </div>
                <div className="text-xs text-white/50 mt-1">特色视频站点</div>
              </div>
              <div className="w-px h-10 bg-white/15 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">
                  每日更新
                </div>
                <div className="text-xs text-white/50 mt-1">海量资源实时同步</div>
              </div>
              <div className="w-px h-10 bg-white/15 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">
                  高清流畅
                </div>
                <div className="text-xs text-white/50 mt-1">多线路不缓冲播放</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#topics"
                onClick={(e) => handleScroll(e, '#topics')}
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-white font-medium text-sm transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                探索热门话题
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleScroll(e, '#ranking')}
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-white/10 hover:bg-white/20 text-white border border-white/25 font-medium text-sm transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-trophy-line text-lg"></i>
                查看热度榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20digital%20entertainment%20platform%20visualization%20with%20floating%20video%20thumbnails%20and%20play%20buttons%20arranged%20in%20dynamic%20composition%20warm%20coral%20red%20and%20gold%20accents%20against%20deep%20charcoal%20background%20cinematic%20lighting%20effects%20sleek%20modern%20UI%20elements%20professional%20digital%20art%20style%20high%20detail&width=800&height=600&seq=hero-visual-69video&orientation=squarish"
                alt="69视频 - 特色视频网站聚合平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}